
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-help",
      function () {
        return require("private-next-pages/how-to-help.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-help"])
      });
    }
  